import type { Skater } from "../skater";
import { surfaceAt } from "../level";
import { bail } from "./bail";
import type { SkaterEvent } from "./state";

// Riding out past the fence (#189): a coaster's track (`Rail.track`) runs
// outside the park, and while you grind it you go with it. Anywhere outside,
// off it (bailing off, ollieing off, the ride ending) is a bail, and once
// it's over you're back at the last safe spot inside the walls, like the
// sea's Wipeout (`sim/beach.ts`). Only maps with track rails get here, so
// every other map skates exactly as before.

/** After each step on a map with a ride's track: remembers the last safe spot, and bails you back inside from out past the fence. */
export function stepRideOut(sk: Skater, events: SkaterEvent[]): void {
  if (sk.mode === "ground" && sk.wipeout) {
    sk.respawn(sk.lastSafe);
    events.push({ type: "respawn" });
    return;
  }
  if (sk.mode === "grind" || sk.mode === "bail") return;
  if (!sk.outOfBounds(sk.x, sk.z)) {
    if (sk.mode !== "ground") return;
    const s = surfaceAt(sk.level, sk.x, sk.z);
    if (s.h === 0 && s.gx === 0 && s.gz === 0) sk.lastSafe = { x: sk.x, z: sk.z, yaw: sk.yaw };
    return;
  }
  bail(sk, events, true);
  sk.wipeout = true;
  sk.vx = sk.vz = 0;
}
